<template>
    <div :class="['container','o-combobox','selectdiv', 'floating', border ? 'border' : '']"
         :style="{width: width,flexGrow:flexGrow}">
        <!--<span class="inputName">{{label}}</span>-->
        <input spellcheck="false" :class="['o-combobox__input', 'floating__input']"
               :ref="'combobox'" v-click-outside="closeDropdown"
               @input="filter" v-model="selected" :disabled="disabled" :required="this.isRequired"
               v-on:click="showDropdown" s
               v-on:keydown.tab.prevent="enterClicked(selectedIndex)"
               v-on:keyup.enter.prevent="enterClicked(selectedIndex)" v-on:keydown.down.prevent="selectNext()"
               v-on:keydown.up.prevent="selectPrev()"/>

        <label class="floating__label" :data-content="label"></label>
        <ul ref="siteWrapper" :class="['o-date-list',deleteSelected?'relative':'absolute', itemWrapperAbsolute]"
            v-show="showAutocompleteDropdown">
            <li :ref="item[itemName]" class="o-date-list__item"
                v-for="(item,index) in filteredItems" :key="item[itemName] + '-' + index"
                v-on:click.prevent="select(index)"
                :class="{'o-date-list__item--selected': index === selectedIndex, hide: item.hide}">
                {{ item[itemName] }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "Dropdown",
    data: function () {
        return {
            item: "",
            showAutocompleteDropdown: false,
            selectedIndex: 0,
            selected: '',
            filteredItems: [],
        }
    },
    props: {
        placeholder: {
            type: String,
            required: false
        },
        disabled: {
            type: Boolean,
            required: false
        },
        deleteSelected: {
            type: Boolean,
            default: true
        },
        label: {
            type: String,
            required: false
        },
        width: {
            type: String,
            default: '300px'
        },
        flexGrow: {},
        initial: {
            type: String,
            required: false,
        },
        required: {
            type: Boolean,
            default: false
        },
        editable: {
            type: Boolean,
            default: true
        },
        selectOnClick: {
            type: Boolean,
            default: false
        },
        items: {
            type: Array
        },
        border: {
            type: Boolean,
            default: true
        },
        itemName: {
            type: String,
            default: 'name'
        },
        itemWrapperAbsolute: {
            type: Boolean,
            default: false
        },
        noReInit: {
            type: Boolean,
            default: false
        },
    },
    mounted() {
        this.filteredItems = this.items;
        if (this.initial && this.initial !== '') {
            this.select(this.findExactInItems(this.initial), true);
        }
    },
    watch: {
        items() {
            if (JSON.stringify(this.filteredItems) !== JSON.stringify(this.items)) {
                this.filteredItems = this.items;
                if (this.initial && this.initial !== '' && !this.noReInit) {
                    this.select(this.findExactInItems(this.initial), true);
                }
            }
        }
    },
    computed: {
        isRequired() {
            return this.required && this.selected === '';
        }
    },
    methods: {
        select: function (index, init = false) {
            if (index !== -1 && this.selected !== this.filteredItems[index][this.itemName]) {
                this.showAutocompleteDropdown = false;
                this.selected = this.filteredItems[index][this.itemName];
                this.$refs['combobox'].focus();
                if ((!this.deleteSelected && !init) || this.selectOnClick) {
                    this.$emit('enter', this.filteredItems[index]);
                }
            }
        },
        selectNext: function () {
            if (this.showAutocompleteDropdown) {
                if (this.selectedIndex < this.filteredItems.length - 1) {
                    this.selectedIndex++;
                    this.$refs[this.filteredItems[this.selectedIndex][this.itemName]][0].scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest'
                    })
                } else {
                    this.selectedIndex = 0;
                }
            } else {
                this.showAutocompleteDropdown = true;
            }

        },
        selectPrev: function () {
            if (this.selectedIndex > 0) {
                this.selectedIndex--;
                this.$refs[this.filteredItems[this.selectedIndex][this.itemName]][0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                })
            } else {
                this.selectedIndex = this.filteredItems.length - 1;
            }
        },
        showDropdown() {
            this.showAutocompleteDropdown = true
        },
        closeDropdown() {
            this.showAutocompleteDropdown = false
        },
        enterClicked(selectedIndex) {
            if (this.showAutocompleteDropdown) {
                this.select(selectedIndex);
            } else {
                let index = !this.editable ? this.findExactInItems(this.selected) : this.findInItems(this.selected);
                if ((index !== -1 && this.deleteSelected) || !this.deleteSelected) {
                    if (index !== -1) {
                        if (!this.editable && this.items[index][this.itemName] !== this.selected.trim()) {
                            this.$noty.error('Kein passender Wert gefunden');
                        } else {
                            if (this.items[index][this.itemName] !== this.selected.trim()) {
                                this.items[index].edited = this.selected;
                            }
                            this.$emit('enter', this.items[index]);
                            //this.showDropdown();
                            if (this.deleteSelected) {
                                this.selected = '';
                            }
                        }
                    } else {
                        if (this.editable) {
                            this.$emit('enter', {edited: this.selected});
                        } else {
                            this.$noty.error('Kein passender Wert gefunden');
                        }
                        //this.showDropdown();
                    }
                    this.filteredItems = this.items;
                } else {
                    if (this.editable && index === -1) {
                        this.$emit('enter', {edited: this.selected});
                    } else {
                        this.$noty.error('Ungültige Eingabe');
                    }
                }
            }
        },
        filter: function () {
            if (this.selected.trim() === '') {
                this.filteredItems = this.items;
            }
            let ret = [];
            for (let i = 0; i < this.items.length; i++) {
                let itemName = this.items[i][this.itemName] + '';
                if (itemName.toLowerCase().indexOf(this.selected.toLowerCase()) !== -1) {
                    ret.push(this.items[i]);
                }
            }
            if (this.filteredItems.length === 0) {
                this.showAutocompleteDropdown = false;
            } else {
                this.showAutocompleteDropdown = true;
            }
            this.filteredItems = ret;
        },
        findInItems(name) {
            for (let i = 0; i < this.items.length; i++) {
                if (name.indexOf(this.items[i][this.itemName]) !== -1) {
                    return i;
                }
            }
            return -1;
        },
        findExactInItems(name) {
            for (let i = 0; i < this.items.length; i++) {
                if (name === this.items[i][this.itemName]) {
                    return i;
                }
            }
            return -1;
        }
    }
}
</script>

<style lang="scss" scoped>


.o-date-list {

    background: white;
    border: 1px solid rgba(0, 0, 0, 0.08);
    padding: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    z-index: 1000;
    margin-top: 0;
    max-height: 15em;

}

.relative {
    position: relative;
}

.absolute {
    position: absolute;
}

.o-date-list__item {
    margin: 0;
    list-style-type: none;
    padding: 0.5rem;
    font-size: 14px;

    display: block;

    text-align: center;
    cursor: pointer;

}

.o-date-list__item:hover {
    opacity: 0.5;
}

.o-date-list__item--selected {
    background: rgba(0, 0, 0, 0.1);
}

.container {
    position: relative;
}

/*
    .inputName {
        position: absolute;
        left: 10px;
        top: 5px;
        font-size: 11px;
        color: #777;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -o-user-select: none;
    }*/

select {
    padding: 1.2em 0.5em 0.5em 0.5em;
    font-size: 15px;
    width: 100%;
    border-color: #d0d4da;
}

select:disabled {
    background: transparent;
    border-color: transparent;
    border-bottom: 1px solid #ccc;
    color: black;
}

select::-ms-expand {
    display: none;
}

.selectdiv:after {
    content: '<>';
    font: 17px "Consolas", monospace;
    color: #333;
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
    right: 11px;
    /*Adjust for position however you want*/

    top: 13px;
    padding: 0 0 2px;

    position: absolute;
    pointer-events: none;
}

:required {
    border: 2px solid #d70364 !important;
}

.floating {
    margin-bottom: 10px;
    background-color: transparent;
    transition: background-color 0.2s ease;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.floating__input {
    padding: 1rem 2rem 0.4rem 0.6rem;
    font-size: 1rem;
    border: none;
    border-bottom: 1px solid #d0d4da;
    transition: border-color 0.2s ease;
    caret-color: #00b6ed;
    width: 100%;

    &:disabled {
        background-color: rgba(255, 255, 255, 0.51);
        cursor: no-drop;
    }
}


.border {
    .floating__input {
        padding: 1rem 2rem 0.4rem 0.6rem;
        border: 1px solid #d0d4da !important;
    }

    .floating__label::before {
        left: 1rem;
    }
}


.floating__input:focus-visible {
    outline: none;
}

.floating__input::placeholder {
    color: rgba(0, 0, 0, 0);
}

.floating__label {
    display: block;
    position: relative;
    max-height: 0;
    font-weight: 400;
    pointer-events: none;
}

.floating__label::before {
    color: #394956;
    content: attr(data-content);
    display: inline-block;
    filter: blur(0);
    backface-visibility: hidden;
    transform-origin: left top;
    transition: transform 0.2s ease;
    left: 0.2rem;
    position: relative;
}

.floating__label::after {
    bottom: 1rem;
    content: "";
    height: 0.1rem;
    position: absolute;
    transition: transform 180ms cubic-bezier(0.4, 0, 0.2, 1),
    opacity 180ms cubic-bezier(0.4, 0, 0.2, 1), background-color 0.3s ease;
    opacity: 0;
    left: 0;
    top: 100%;
    margin-top: -0.1rem;
    transform: scale3d(0, 1, 1);
    width: 100%;
    background-color: #00b6ed;
}

.floating__input:focus + .floating__label::after {
    transform: scale3d(1, 1, 1);
    opacity: 1;
}

.floating__input:placeholder-shown + .floating__label::before {
    transform: translate3d(0, -1.7rem, s 0) scale3d(1, 1, 1);
}

.floating__label::before,
.floating__input:focus + .floating__label::before {
    transform: translate3d(-5px, -2.50rem, 0) scale3d(0.72, 0.72, 1);
}

.floating__input:focus + .floating__label::before {
    color: #00b6ed;
}

::v-deep .o-date-list__item.hide {
    display: none;
}
</style>